import { useState } from "react";
import { useTranslation } from "react-i18next";
import submit from "submit-form";

const refreshSearch = (workoutSearch, folderId) => {
  submit("/actions/refresh", {
    method: "GET",
    body: {
      workoutSearch,
      // Empty string clears a folder left in the query. An open folder passes
      // its id so the search stays inside that folder.
      folderId: folderId || "",
      tabView: "single-workouts-tab",
      templateView: "single-workouts",
    },
  });
};

const SavedWorkoutSearch = ({ workoutSearch = "", folderId = "" }) => {
  const { t } = useTranslation(["coaching-portal", "common"]);
  const [value, setValue] = useState(workoutSearch);

  const applySearch = (event) => {
    event.preventDefault();
    refreshSearch(value.trim(), folderId);
  };

  return (
    <form className="saved-workout-search" onSubmit={applySearch}>
      <input
        type="search"
        name="workoutSearch"
        value={value}
        onChange={(event) => {
          const next = event.target.value;
          setValue(next);
          // The native clear control empties the field without submitting.
          if (next === "" && workoutSearch) refreshSearch("", folderId);
        }}
        placeholder={t("allTemplates.singleWorkouts.searchPlaceholder")}
        aria-label={t("allTemplates.singleWorkouts.searchLabel")}
        autoComplete="off"
      />
      <button type="submit" data-button-type="outline">
        {t("common:search")}
      </button>
    </form>
  );
};

export default SavedWorkoutSearch;
